<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Suburb</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <suburb-form :data="data"></suburb-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import SuburbForm from './SuburbForm'
import { axios } from '../../../utils'
import FormErrors from '../../../components/FormErrors'
export default {
  name: 'SuburbDialog',
  data() {
    return {
      data: {
        name: '',
        postcode: '',
        latitude: '',
        longitude: '',
        region: ''
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'suburbs', 'item'],
  components: {
    SuburbForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting suburb data for id ', this.item.id)
      axios
        .get('api/admin/suburbs/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new suburbs')
      axios
        .post('api/admin/suburbs/create', {
          name: this.data.name,
          postcode: this.data.postcode,
          latitude: this.data.latitude,
          longitude: this.data.longitude,
          region: this.data.region
        })
        .then(res => {
          console.log(res.data)
          console.log('done')

          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      this.loading = true
      console.log('updating suburb data for id ', this.item.id)
      axios
        .put(`api/admin/suburbs/${this.item.id}`, {
          name: this.data.name,
          postcode: this.data.postcode,
          latitude: this.data.latitude,
          longitude: this.data.longitude,
          region: this.data.region
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        name: '',
        postcode: '',
        latitude: '',
        longitude: '',
        region: ''
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
